import React from 'react';
import ProfileLayout from '../../components/ProfileLayout';
import ChatContent from '../../components/ChatContent';

const ChatPage = () => {
  return (
    <ProfileLayout activeItem="chat">
      <ChatContent />
    </ProfileLayout>
  );
};

export default ChatPage;

